
import { computed, defineComponent, PropType, reactive, ref, toRefs, watch } from 'vue'
import EditableBlock from '@/components/EditableBlock.vue'
import { UUID } from '@Protium/vue-ozone-utils'
import ChevronRightIcon from '@/components/Icons/ChevronRightIcon.vue'
import EditableBlockInput from '@/components/EditableBlockInput.vue'
import Tooltip from '@/components/Tooltip.vue'
import DButton from '@/components/base/DButton.vue'
import AddIcon from '@/components/Icons/AddIcon.vue'
import EditableBlockSelect from '@/components/EditableBlockSelect.vue'
import TrashIcon from '@/components/Icons/TrashIcon.vue'
import CloseIcon from '@/components/Icons/CloseIcon.vue'
import TickIcon from '@/components/Icons/TickIcon.vue'
import { useQuasar } from 'quasar'
import LabelBox from '@/pages/Products/components/LabelBox.vue'

type PrinterType = 'printer'

interface Printer {
  sys?: {
    id: UUID,
    type: PrinterType
  },
  id: string,
  type?: string,
  name?: string,
  tags?: Array<string>,
  status?: string,
  location?: string,
  meta?: Record<string, any>,
}

export default defineComponent({
  name: 'PrinterInformation',
  components: {
    LabelBox,
    TickIcon,
    CloseIcon,
    TrashIcon,
    EditableBlockSelect,
    AddIcon,
    DButton,
    Tooltip,
    EditableBlockInput,
    ChevronRightIcon,
    EditableBlock
  },
  emits: ['add-printer', 'remove-printer'],
  props: {
    printers: {
      type: Array as PropType<Array<Printer>>,
      required: true,
    },
    collection: {
      type: Array as PropType<Array<Printer>>,
      required: true,
    },
    channels: {
      type: Array,
      required: true,
    },
  },

  setup (props, { emit }) {
    const $q = useQuasar()
    const activePrinter = ref<Printer | undefined>((props.printers?.[0]))
    const editing = ref(false)

    const printerTypeOptions = [{
      label: 'Shipment label',
      value: 'shipment-label',
    }, {
      label: 'Picking label',
      value: 'picking-label',
    }, {
      label: 'Packing slip',
      value: 'packing-slip',
    }, {
      label: 'Invoice',
      value: 'invoice',
    }]

    watch(() => [props.printers], () => {
      activePrinter.value = props.printers?.[0]
    })

    function getDisplayValue (object, value) {
      for (let i = 0; i < object.length; i++) {
        if (object[i].value === value) {
          return object[i].label
        }
      }
      return null
    }

    const addPrinter = reactive({
      addPrinterModal: false,
      addedPrinter: undefined,
    })

    const setActivePrinter = (printerId) => {
      activePrinter.value = props.printers.find(printer => printer.sys?.id === printerId)
    }

    const filteredCollection = computed(() => {
      return !props.printers?.length ? props.collection : props.collection.filter(obj1 =>
        !props.printers.some(obj2 => obj2.id.toString() === obj1.id.toString())
      )
    })

    const handleRemovePrinter = (printer) => {
      $q.dialog({
        title: `Are you sure you want to unlink ${printer.name}?`,
        cancel: true,
        persistent: false
      }).onOk(() => {
        emit('remove-printer', printer)
      })
    }

    return {
      ...toRefs(addPrinter),
      activePrinter,
      editing,
      printerTypeOptions,
      getDisplayValue,
      setActivePrinter,
      handleRemovePrinter,
      filteredCollection
    }
  }
})
